import { ArrowRightLeft } from "lucide-react";

import { importSuffix } from "components/LogItem/messages/importSuffix";
import {
  getMachinesPageLink,
  getModelLink,
} from "components/LogItem/messages/modelLinks";

// Both halves of a move carry the same info, so one message serves the entry
// filed under the previous case and the one filed under the new case. Neither
// entry follows the machine on a later move, so the machine link targets the
// global Machines page rather than the destination case.
const renderTransferMessage = ({ info }) => {
  const { machine_id, from_case, to_case, data_job_id } = info;
  return (
    <p>
      {getMachinesPageLink(machine_id)} was transferred from case{" "}
      {getModelLink(from_case.id, "Case", { label: from_case.name })} to case{" "}
      {getModelLink(to_case.id, "Case", { label: to_case.name })}
      {importSuffix(data_job_id)}.
    </p>
  );
};

export const MACHINE_EVENTS = {
  machine_transferred_in: {
    title: "Machine Transferred In",
    icon: ArrowRightLeft,
    message: renderTransferMessage,
  },
  machine_transferred_out: {
    title: "Machine Transferred Out",
    icon: ArrowRightLeft,
    message: renderTransferMessage,
  },
};
